export const TURNSTILE_CONFIG = {
  TURNSTILE_SITE_KEY: process.env.NEXT_PUBLIC_TURNSTILE_KEY || '',
};
